import { render } from "./DonationCategoryManageListForm.vue?vue&type=template&id=4cd2b0d2&lang=true"
import script from "./DonationCategoryManageListForm.vue?vue&type=script&lang=js"
export * from "./DonationCategoryManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__